// src/components/comments/ReplyComposer.jsx
//
// The reply box on a comment card. It used to live inside the expanded thread,
// below the existing replies, and opened only once you had clicked "Replies";
// there was a second route to the same thing via the card's overflow menu,
// which swapped the whole card into a reply mode. Both are gone. This is now
// the one way to reply and it is always on the card, so replying costs no
// clicks before the typing.
//
// It therefore has exactly one caller (CommentCard) and is styled for it: ink
// on white, gold send, matching CardButton rather than the purple thread it
// used to sit in.
import React, { useState } from "react";

const GOLD = '#D4AF37';
const GOLD_HOVER = '#F5D76E';
const INK = '#1A1A1A';

export default function ReplyComposer({ busy, onSubmit }) {
  const [text, setText] = useState("");

  const submit = () => {
    const t = (text || "").trim();
    if (!t || busy) return;
    onSubmit && onSubmit(t);
    setText("");
  };

  const canSend = Boolean(text.trim()) && !busy;

  return (
    // Wraps so the button drops under the box when the card is narrow.
    <div className="reply-composer" style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
      <input
        type="text"
        placeholder="Write a reply…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
          if (e.key === "Escape") setText("");
        }}
        style={{
          flex: 1,
          minWidth: 110,
          padding: "7px 10px",
          border: "1px solid rgba(0,0,0,0.18)",
          borderRadius: 6,
          fontSize: 13,
          color: INK,
          background: '#FFFFFF',
        }}
        disabled={busy}
      />
      <button
        type="button"
        onClick={submit}
        disabled={!canSend}
        style={{
          font: 'inherit', fontSize: 12, fontWeight: 700, lineHeight: 1,
          padding: "8px 14px",
          borderRadius: 6,
          flexShrink: 0,
          color: INK,
          backgroundColor: canSend ? GOLD : '#FFFFFF',
          border: `1px solid ${canSend ? GOLD : 'rgba(0,0,0,0.18)'}`,
          cursor: canSend ? 'pointer' : 'default',
          opacity: canSend ? 1 : 0.5,
        }}
        onMouseEnter={(e) => { if (canSend) e.currentTarget.style.backgroundColor = GOLD_HOVER; }}
        onMouseLeave={(e) => { if (canSend) e.currentTarget.style.backgroundColor = GOLD; }}
      >
        Reply
      </button>
    </div>
  );
}
